(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/ticketgames/ticket-utility/assets/javascripts/utils/normalize-win-retail.js') >= 0) return;  svs.modules.push('/components/ticketgames/ticket-utility/assets/javascripts/utils/normalize-win-retail.js');
"use strict";


const {
  KLOVER_ICON_LEIA: MONTH_WIN_TRISS,
  TV_ICON_LEIA: TV_WIN,
  WEEK_ICON_LEIA: WEEK_WIN,
  WEEK_50000X6_ICON_LEIA: WEEK_WIN_50000X6,
  UNKNOWN_HIGH_WIN
} = svs.bubble_win_message.extraIcon;

const HIGH_WIN_NO_PAYOUT = 'HIGH_WIN_NO_PAYOUT';
const WIN = 'WIN';
const NO_WIN = 'NO_WIN';
const WIN_NON_FIXED_PRIZE = 'WIN_NON_FIXED_PRIZE';
const MERCHANDISE = 'MERCHANDISE';
const UNDEFINED = 'UNDEFINED';
const prizeDescriptionMap = {
  [MONTH_WIN_TRISS]: ['(2 765 000x1) KLOVER', '(2 765 000) KLOVER', 'MONTH_WIN_TRISS'],
  [TV_WIN]: ['(265 000x1) TV-Triss', '(265 000) TV-TRISS', 'TV_WIN_TRISS'],
  [WEEK_WIN]: ['VECKOVINST 15.000 /v i 1 ar', 'WEEK_WIN_15000X52'],
  [WEEK_WIN_50000X6]: ['(300 000) 50.000/v. i 6 veckor', 'WEEK_WIN_50000X6']
};
const prizeDescriptionWordsMatch = {
  [MONTH_WIN_TRISS]: ['KLOVER', 'KLÖVER', 'MONTH_WIN_TRISS'],
  [TV_WIN]: ['TV', 'TV-TRISS', 'TV_WIN_TRISS']
};
const normalizeWinRetailConstants = {
  HIGH_WIN_NO_PAYOUT,
  WIN,
  NO_WIN,
  winTypes: {
    WIN_NON_FIXED_PRIZE,
    MERCHANDISE,
    UNDEFINED
  },
  winMessage: {
    [MONTH_WIN_TRISS]: 'Klöver',
    [TV_WIN]: 'TV',
    [WEEK_WIN]: 'Veckovinst',
    [WEEK_WIN_50000X6]: 'Veckovinst',
    SPECIAL_WIN: 'Specialvinst'
  }
};
const SPECIAL_WINS = [normalizeWinRetailConstants.HIGH_WIN_NO_PAYOUT];
setGlobal('svs.ticketUtility.utils.normalizeWinRetailConstants', normalizeWinRetailConstants);
setGlobal('svs.ticketUtility.utils.normalizeWinRetail', res => {
  const {
    winAmount,
    result,
    winType,
    prizeDescription
  } = res;
  let extraicon = null;
  const amount = parseInt(winAmount, 10);
  let winMessage = "".concat(svs.utils.format.Currency(amount), " kr");
  const winFlag = amount > 0;
  if (SPECIAL_WINS.includes(result)) {
    const prizeDescTrimmed = (prizeDescription || '').trim();
    for (const [key, value] of Object.entries(prizeDescriptionMap)) {
      if (value.includes(prizeDescTrimmed)) {
        extraicon = key;
        winMessage = normalizeWinRetailConstants.winMessage[key];
        break;
      }
    }
    if (!extraicon) {
      for (const [key, value] of Object.entries(prizeDescriptionWordsMatch)) {
        const prizeDesc = prizeDescTrimmed.toUpperCase();
        const wordMatch = value.find(v => prizeDesc.includes(v));
        if (wordMatch) {
          extraicon = key;
          winMessage = normalizeWinRetailConstants.winMessage[key];
          svs.ticketgames.ticketUtility.logger.info("Found word match ('".concat(wordMatch, "') in prizeDescription ('").concat(prizeDescription, "') ").concat(JSON.stringify({
            prizeDescription,
            result,
            extraicon,
            winMessage
          })));
          break;
        }
      }
    }
    if (!extraicon) {
      extraicon = UNKNOWN_HIGH_WIN;
      winMessage = normalizeWinRetailConstants.winMessage.SPECIAL_WIN;
      svs.ticketgames.ticketUtility.logger.warn("No applicable extra icon found for object ".concat(JSON.stringify({
        winAmount,
        result,
        winType,
        prizeDescription
      })));
    }
  }
  return {
    extraicon,
    amount,
    winFlag,
    winMessage
  };
});

 })(window);